import navBarHomepage from '../modules/navbar-homepage';
import signUp from '../modules/sign_up';
import fbAuth from '../modules/fb_auth';
import twitterAuth from '../modules/twitter_auth';

let signupController = () => {
    navBarHomepage.on();
    signUp.on();
    fbAuth.on();
    twitterAuth.on();
};

export default signupController;
